import React from 'react'
import { IoIosCall } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom"
import { FaFacebookF } from "react-icons/fa6";
import { AiFillInstagram } from "react-icons/ai";
import { FaViber } from "react-icons/fa";

function Footer() {
  const viberNumber = "+38974229595"; // Твојот број
  const viberLink = `viber://chat?number=${encodeURIComponent(viberNumber)}`;
  const viberWebLink = `https://invite.viber.com/?g2=demo&lang=en&number=${encodeURIComponent(viberNumber)}`;

  const handleViberClick = (event) => {
    // Ако е на десктоп, ќе користиме веб линк, ако е на мобилен ќе го користиме viber://
    if (navigator.userAgent.match(/iPhone|iPad|Android/i)) {
      // Ако е мобилен, користи viber://
      window.location.href = viberLink;
    } else {
      // Ако е десктоп, користи веб линк
      window.open(viberWebLink, "_blank");
    }
  };


  return (
    <footer className="footer bg-neutral text-neutral-content p-10 flex flex-col justify-between">
      <div className="footer-container flex flex-col sm:flex-row sm:space-x-6 justify-center w-full max-w-4xl mx-auto flex-grow">

        {/* Контакт */}
        <nav className="flex flex-col items-center sm:items-start max-w-[700px] w-full mb-6 sm:mb-0">
          <h6 className="footer-title">Контакт</h6>
          <div className="flex items-center space-x-2">
            <IoIosCall className="text-xl" />
            <span>+389 74 22 95 95</span>
          </div>
          <div className="flex items-center space-x-2 mt-2">
            <FaViber className="text-xl" />
            <a href={viberLink} onClick={handleViberClick} target="_blank" rel="noopener noreferrer">
              {viberNumber}
            </a>
          </div>
          <div className="flex items-center space-x-2 mt-2">
            <MdEmail className="text-xl" />
            <span>contact@malservis.mk</span>
          </div>
        </nav>

        {/* Company */}
        <nav className="flex flex-col items-center  max-w-[700px] w-full mb-6 sm:mb-0 min-w-[170px]">
          <h6 className="footer-title">За компанијата</h6>
          <Link to="/about" className="link link-hover hover:text-myOrange">
            За нас
          </Link>
          <Link to="/visionandmission" className="link link-hover hover:text-myOrange">
            Визија и Мисија
          </Link>
          <Link to="/deliverypolicy" className="link link-hover hover:text-myOrange">
            Политика за достава
          </Link>
          <Link to="/privacypolicy" className="link link-hover hover:text-myOrange">
            Политика на приватност
          </Link>
          <Link to="/termsofuse" className="link link-hover hover:text-myOrange">
            Услови на користење
          </Link>
          <Link to="/blogList" className="link link-hover hover:text-myOrange">
            Блог
          </Link>
        </nav>

        {/* Social */}
        <nav className="flex flex-col items-center max-w-[700px] w-full">
          <h6 className="footer-title">Социјални медиуми</h6>
          <div className="grid grid-flow-col gap-4">
            <a href="https://www.facebook.com/profile.php?id=61575622274790" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="text-2xl" />
            </a>
            <a href="https://www.instagram.com/malservis.mk/" target="_blank" rel="noopener noreferrer">
              <AiFillInstagram className="text-2xl" />
            </a>
          </div>
        </nav>
      </div>

      <div className="w-full footer-center  mt-2">
        <p className='text-center'>malservis.mk | Сите права се задржани.</p>
      </div>
    </footer>

  )
}

export default Footer
